export const callLink = "callto:5083164751";
export const mailLink = "mailto:questions@beyondthebelleducation.com";
export const mapsLink = "https://goo.gl/maps/huC9JcTuWy1PebMP7";
export const facebookLink = "https://www.facebook.com/beyondthebelled/";